import React from 'react';
import './Footer.css'
const Footer = () => {
  const yearDate = new Date().getFullYear()
  return (
    <div className='footer_area text-center'>
      <h3 className='mt-4'>- Creative Photo Studio</h3>
      <p className='text-danger'>I Work Worldwide</p>
      <h1>Hello@domain.com</h1>
      <h5>(+01). 234. 567. 890</h5>
      <p><small>&copy; {yearDate} Frame It, All right reserved</small></p>
    </div>
  );
};

export default Footer;